export const INTEREST_OPTIONS = [
  { value: "", label: "All" },
  { value: "PRODUCT", label: "Products" },
  { value: "SERVICE", label: "Services" },
  { value: "CONTRACTS", label: "Contracts" },
  { value: "VACANCY", label: "Vacancies" },
  { value: "APPRENTICESHIP", label: "Apprenticeships" },
  { value: "WORK_EXPERIENCE", label: "Experiences of work" },
  { value: "COURSES", label: "Courses" },
];

export const TAB_VALUE_MAP = {
  PRODUCT: "product",
  SERVICE: "service",
  CONTRACTS: "contract",
  VACANCY: "vacancy",
  APPRENTICESHIP: "apprenticeship",
  WORK_EXPERIENCE: "work-experience",
  COURSES: "courses",
};

const SIZE_LABEL_MAP = {
  MICRO: "Micro 0-9",
  SMALL: "Small 10-49",
  MEDIUM: "Medium 50-249",
  LARGE: "Large 250+",
};

export function getInterestLabel(value) {
  return INTEREST_OPTIONS.find((o) => o.value === value)?.label || value;
}

export function getTabValue(interest) {
  return TAB_VALUE_MAP[interest] || "work-experience";
}

export function getSizeLabel(value) {
  return SIZE_LABEL_MAP[value] || value;
}
